import React, { FC, useEffect, useState } from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { useTextMessages, ITextMessage } from '../../Data/TextMessageData';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import Box from '@mui/material/Box';
import Collapse from '@mui/material/Collapse';
import { ApplicationDocumentsViewer } from '../ApplicationDocumentsViewer';
import { ApplicationPicker } from '../ApplicationPicker';
import TableFooter from '@mui/material/TableFooter';
import TablePagination from '@mui/material/TablePagination';
import Switch from '@mui/material/Switch';
import {hasValue} from "@amsanalytics/react-shared-library";
import styled from 'styled-components';



export interface TextMessagesListProps {
  applicationId?: string;
}

export const TextMessagesList: FC<TextMessagesListProps> = (props) => {
  const [rowsPerPage, setRowsPerPage] = useState<number>(50);
  const [page, setPage] = useState<number>(0);
  const { resolvedData } = useTextMessages({ applicationId: props.applicationId, pageNumber: page, pageSize: rowsPerPage });
  const [textMessages, setTextMessages] = useState<ITextMessage[] | undefined>(resolvedData?.textMessages);
  const [showUnassignedMessages, setShowUnassignedMessages] = useState<boolean>(false);

  useEffect(() => {
    if (showUnassignedMessages) {
      setTextMessages(resolvedData?.textMessages.filter((tm) => !hasValue(tm.applicationId)));
    } else {
      setTextMessages(resolvedData?.textMessages);
    }
  }, [resolvedData, showUnassignedMessages]);

  return (
    <div style={{ padding: 24, width: '100%' }}>
      {/* <Typography variant="h4">Text Messages</Typography> */}
      <TableContainer component={Paper}>
        <Table style={{minWidth: '650px'}} aria-label='text messages' size='small'>
          <TableHead>
            <TableRow>
              <TableCell></TableCell>
              <TableCell>
                <span style={{ marginRight: '2rem' }}>Message</span>
                <Switch
                  checked={showUnassignedMessages}
                  onChange={(e) => {
                    setShowUnassignedMessages(e.target.checked);
                  }}
                  color='primary'
                  inputProps={{ 'aria-label': 'primary checkbox' }}
                />
                <span aria-label='Show Only Unassigned toggle'>Show Only Unassigned</span>
              </TableCell>
              <TableCell>Attachments</TableCell>
              <TableCell>From</TableCell>
              <TableCell>To</TableCell>
              <TableCell>Date</TableCell>
              <TableCell>Application</TableCell>
              <TableCell></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {textMessages?.map((row) => (
              <Row key={row.id} row={row} />
            ))}
          </TableBody>
          <TableFooter>
            <TableRow>
              <TablePagination
                rowsPerPageOptions={[10, 25, 50, 100, 1000]}
                colSpan={8}
                rowsPerPage={rowsPerPage}
                count={resolvedData?.total || 0}
                page={page}
                SelectProps={{ native: true }}
                onPageChange={(e, p) => setPage(p)}
                onRowsPerPageChange={(event: any) => {
                  setPage(0);
                  setRowsPerPage(parseInt(event.target.value));
                }}
              />
            </TableRow>
          </TableFooter>
        </Table>
      </TableContainer>
    </div>
  );
};

const Row = (props: { row: ITextMessage }) => {
  const { row } = props;
  const [open, setOpen] = React.useState(false);
  const StyledTableRow = styled(TableRow)({
  '& > .MuiTableCell-root': {
    borderBottom: 'unset',
  },
});
  return (
    <>
      <StyledTableRow hover>
        <TableCell>
          <IconButton aria-label='expand row' size='small' onClick={() => setOpen(!open)}>
            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
        </TableCell>
        <TableCell>{row.message}</TableCell>
        <TableCell>
          <ApplicationDocumentsViewer applicationDocuments={row.applicationDocuments || []} />
        </TableCell>
        <TableCell style={{whiteSpace: 'nowrap'}}>{row.phoneNumberFrom}</TableCell>
        <TableCell style={{whiteSpace: 'nowrap'}}>{row.phoneNumberTo}</TableCell>
        <TableCell>{row.createdDateFormatted}</TableCell>
        <TableCell>
          <a href={`/order/${row.applicationId}`}>{row.application?.applicationNo}</a>
        </TableCell>
        <TableCell>
          <ApplicationPicker textMessageId={row.id} />
        </TableCell>
      </StyledTableRow>
      <StyledTableRow>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={8}>
          <Collapse in={open} timeout='auto' unmountOnExit>
            <Box margin={1}>
              <Typography variant='h6' gutterBottom component='div'>
                Details
              </Typography>
              <pre>{row.json}</pre>
            </Box>
          </Collapse>
        </TableCell>
      </StyledTableRow>
    </>
  );
};
